import axiosClient from './axiosClient';

const chargeModelApi = {
  // lay danh sach models
  getChargeModelList: (params) => {
    const url = '/charger/model';
    return axiosClient.get(url, { params });
  },

  // lay thong tin chi tiet models
  getChargeModelDetail: (chargeModelId) => {
    const url = `/charger/model/${chargeModelId}`;
    return axiosClient.get(url);
  },

  // tao models
  createChargeModel: (params) => {
    const url = '/charger/model/create';
    return axiosClient.post(url, params);
  },

  // cap nhat thong tin models
  updateChargeModel: (chargeModelId, params) => {
    const url = `/charger/model/${chargeModelId}`;
    return axiosClient.put(url, params);
  },

  // xoa models
  deleteChargeModel: (chargeModelId) => {
    const url = `/charger/model/${chargeModelId}`;
    return axiosClient.delete(url);
  },
};

export default chargeModelApi;
